<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpBox
    direction="column"
  >
    <ItpBox
      direction="column"
      v-if="items && items.length"
    >
      <ItpBox
        :key="item.id"
        alignItems="start"
        class="border rounded rounded-lg p-2 mb-2 w-100"
        v-for="item in items"
        :style="b_6466705138206980_style"
      >
        <ItpText
          strong
          :text="item.transaction.transaction_date | date"
          class="mr-3"
        >
        </ItpText>
        <ItpBox
          direction="column"
          class="mr-3"
        >
          <DIV>
            <ItpLink
              :text="item.transaction.transaction_number"
              strong
              @click="evh_4592790460410433_click($event, {item})"
            >
            </ItpLink>
          </DIV>
          <UcAccountMiniCard
            :item="item.account"
          >
          </UcAccountMiniCard>
        </ItpBox>
        <ItpBox
          class="ml-auto"
        >
          <UcPaymentTransactionTypeSymbol
            :transactionType="item.transaction.transaction_type"
            class="mx-2"
          >
          </UcPaymentTransactionTypeSymbol>
          <ItpText
            strong
            class="ml-auto"
          >
            {{ item.amount | number }} {{ item.currency }}

          </ItpText>
        </ItpBox>
      </ItpBox>
    </ItpBox>
    <ItpBox
      class="px-2 mb-2 w-100"
      v-if="items && items.length > 1"
    >
      <ItpText>
        {{ 'Total'|pgettext('InvoicePayments') }}
      </ItpText>
      <ItpText
        strong
        class="ml-auto"
      >
        {{ invoice.totals.paid | number }} {{ invoice.currency }}

      </ItpText>
    </ItpBox>
    <ItpBox
      direction="row"
      alignItems="center"
    >
      <DIV
        class="form-check px-0"
      >
        <ItpFormCheckbox
          name="no_payment_required"
          v-model="invoice.no_payment_required"
          is-switch
          class="py-1"
          @change="evh_322074727583344_change($event, {})"
        >
          {{ 'No payment required'|pgettext('Invoice') }}
        </ItpFormCheckbox>
        <ItpFormCheckbox
          name="uncollectible"
          v-model="invoice.uncollectible"
          is-switch
          class="py-1"
          @change="evh_5807883900791941_change($event, {})"
        >
          {{ 'Uncollectible'|pgettext('Invoice') }}
        </ItpFormCheckbox>
      </DIV>
      <b-dropdown
        right
        variant="light"
        class="border, ml-auto"
      >
        <template
          slot="button-content"
        >
          <ItpIcon
            fa="bars"
            class="mx-1"
          >
          </ItpIcon>
          <ItpText
            :text="'New payment'|pgettext('InvoicePayments')"
          >
          </ItpText>
        </template>
        <b-dropdown-item-button
          @click.prevent="evh_1984986731969919_clickPrevent($event, {})"
        >
          <ItpText
            :text="'New cash payment...'|pgettext('InvoicePayments')"
          >
          </ItpText>
        </b-dropdown-item-button>
        <b-dropdown-item-button
          @click.prevent="evh_298505142589676_clickPrevent($event, {})"
        >
          <ItpText
            :text="'New banking payment...'|pgettext('InvoicePayments')"
          >
          </ItpText>
        </b-dropdown-item-button>
        <ItpDropdownDivider>
        </ItpDropdownDivider>
        <b-dropdown-item-button
          @click.prevent="evh_5738488038990219_clickPrevent($event, {})"
        >
          <ItpText
            :text="'New reconciliation...'|pgettext('InvoicePayments')"
          >
          </ItpText>
        </b-dropdown-item-button>
        <b-dropdown-item-button
          @click.prevent="evh_7481595298497917_clickPrevent($event, {})"
        >
          <ItpText
            :text="'Bad debt...'|pgettext('InvoicePayments')"
          >
          </ItpText>
        </b-dropdown-item-button>
      </b-dropdown>
    </ItpBox>
  </ItpBox>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoicePayments extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    default: null,
  })
  reload!: any;

  @Watch('reload')
  onReload(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("reload")
  }

  triggerButtonID!: any;

  async $$load_triggerButtonID() {
    return this.$fn.randomElementId()
  }

  ux!: any;
  b_6466705138206980_style!: any;
  dataMembers = ['triggerButtonID', 'ux', 'b_6466705138206980_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        triggerButtonID: null,
        ux: null,
        b_6466705138206980_style: {
          "min-width": "150px",
        }
        ,
      },
    }
  }

  get items() {
    if (this.loaded) {

      return this.invoice.payments.data
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_4592790460410433_showModal_7658_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4592790460410433_showModal_7658, alias=OpenPayment
    return {
      name: "Payment",
      props: {
        oid: $event.scope.item.transaction.id,
      }
      ,
    }
  }

  async evh_4592790460410433_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4592790460410433_click.executeFromDOM(this, event, scope);
  }

  async act_322074727583344_resource_7660_getActionArgs($event: actions.ActionEvent): Promise<actions.ResourceActionArgs> {
    // parameterResolver name=act_322074727583344_resource_7660, alias=undefined
    return {
      method: "patch",
      target: this.invoice,
      data: {
        no_payment_required: $event.data.checked ? 'true' : null,
      }
      ,
    }
  }

  async evh_322074727583344_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_322074727583344_change.executeFromDOM(this, event, scope);
  }

  async act_5807883900791941_resource_7662_getActionArgs($event: actions.ActionEvent): Promise<actions.ResourceActionArgs> {
    // parameterResolver name=act_5807883900791941_resource_7662, alias=undefined
    return {
      method: "patch",
      target: this.invoice,
      data: {
        uncollectible: $event.data.checked ? 'true' : null,
      }
      ,
    }
  }

  async evh_5807883900791941_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5807883900791941_change.executeFromDOM(this, event, scope);
  }

  async act_1984986731969919_emit_7666_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1984986731969919_emit_7666, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1984986731969919_close_7665_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1984986731969919_close_7665, alias=undefined
    return $event.data.ok
  }

  async act_1984986731969919_showModal_7664_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1984986731969919_showModal_7664, alias=createCashPayment
    return {
      name: "Payment",
      props: {
        transactionKind: "cash_book",
        transactionType: this.invoice.invoice_kind == 'incoming' ? 'payment' : 'deposit',
        invoices: [this.invoice.id],
      }
      ,
    }
  }

  async evh_1984986731969919_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1984986731969919_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_298505142589676_emit_7670_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_298505142589676_emit_7670, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_298505142589676_close_7669_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_298505142589676_close_7669, alias=undefined
    return $event.data.ok
  }

  async act_298505142589676_showModal_7668_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_298505142589676_showModal_7668, alias=createBankingPayment
    return {
      name: "Payment",
      props: {
        transactionKind: "bank",
        transactionType: this.invoice.invoice_kind == 'incoming' ? 'debit' : 'credit',
        invoices: [this.invoice.id],
      }
      ,
    }
  }

  async evh_298505142589676_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_298505142589676_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5738488038990219_emit_7674_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5738488038990219_emit_7674, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5738488038990219_close_7673_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5738488038990219_close_7673, alias=undefined
    return $event.data.ok
  }

  async act_5738488038990219_showModal_7672_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5738488038990219_showModal_7672, alias=createReconciliation
    return {
      name: "Payment",
      props: {
        transactionKind: "technical",
        transactionType: "invoice_reconciliation",
        invoices: [this.invoice.id],
      }
      ,
    }
  }

  async evh_5738488038990219_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5738488038990219_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_7481595298497917_emit_7678_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7481595298497917_emit_7678, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7481595298497917_close_7677_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7481595298497917_close_7677, alias=undefined
    return $event.data.ok
  }

  async act_7481595298497917_showModal_7676_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7481595298497917_showModal_7676, alias=createBadDebt
    return {
      name: "Payment",
      props: {
        transactionKind: "technical",
        transactionType: "write_off",
        invoices: [this.invoice.id],
      }
      ,
    }
  }

  async evh_7481595298497917_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7481595298497917_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7656: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7655: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_4592790460410433_showModal_7658: actions.ShowModalAction;
    evh_4592790460410433_click_7657: actions.EventHandlerImpl;
    evh_4592790460410433_click: actions.EventHandlerGroup;
    act_322074727583344_resource_7660: actions.ResourceAction;
    evh_322074727583344_change_7659: actions.EventHandlerImpl;
    evh_322074727583344_change: actions.EventHandlerGroup;
    act_5807883900791941_resource_7662: actions.ResourceAction;
    evh_5807883900791941_change_7661: actions.EventHandlerImpl;
    evh_5807883900791941_change: actions.EventHandlerGroup;
    act_1984986731969919_emit_7666: actions.EmitAction;
    evh_1984986731969919_close_7665: actions.EventHandlerImpl;
    act_1984986731969919_showModal_7664: actions.ShowModalAction;
    evh_1984986731969919_clickPrevent_7663: actions.EventHandlerImpl;
    evh_1984986731969919_clickPrevent: actions.EventHandlerGroup;
    act_298505142589676_emit_7670: actions.EmitAction;
    evh_298505142589676_close_7669: actions.EventHandlerImpl;
    act_298505142589676_showModal_7668: actions.ShowModalAction;
    evh_298505142589676_clickPrevent_7667: actions.EventHandlerImpl;
    evh_298505142589676_clickPrevent: actions.EventHandlerGroup;
    act_5738488038990219_emit_7674: actions.EmitAction;
    evh_5738488038990219_close_7673: actions.EventHandlerImpl;
    act_5738488038990219_showModal_7672: actions.ShowModalAction;
    evh_5738488038990219_clickPrevent_7671: actions.EventHandlerImpl;
    evh_5738488038990219_clickPrevent: actions.EventHandlerGroup;
    act_7481595298497917_emit_7678: actions.EmitAction;
    evh_7481595298497917_close_7677: actions.EventHandlerImpl;
    act_7481595298497917_showModal_7676: actions.ShowModalAction;
    evh_7481595298497917_clickPrevent_7675: actions.EventHandlerImpl;
    evh_7481595298497917_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7656 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7655 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7656,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7655],
      }
    );
    const act_4592790460410433_showModal_7658 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4592790460410433_showModal_7658_getActionArgs,
        displayName: "OpenPayment",
        events: [],
      }
    );
    const evh_4592790460410433_click_7657 = new actions.EventHandlerImpl(
      {
        action: act_4592790460410433_showModal_7658,
        event: "click",
        displayName: "OpenPayment",
      }
    );
    const evh_4592790460410433_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4592790460410433_click_7657],
      }
    );
    const act_322074727583344_resource_7660 = new actions.ResourceAction(
      {
        actionArgs: this.act_322074727583344_resource_7660_getActionArgs,
        events: [],
      }
    );
    const evh_322074727583344_change_7659 = new actions.EventHandlerImpl(
      {
        action: act_322074727583344_resource_7660,
        event: "change",
        displayName: "resource",
      }
    );
    const evh_322074727583344_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_322074727583344_change_7659],
      }
    );
    const act_5807883900791941_resource_7662 = new actions.ResourceAction(
      {
        actionArgs: this.act_5807883900791941_resource_7662_getActionArgs,
        events: [],
      }
    );
    const evh_5807883900791941_change_7661 = new actions.EventHandlerImpl(
      {
        action: act_5807883900791941_resource_7662,
        event: "change",
        displayName: "resource",
      }
    );
    const evh_5807883900791941_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_5807883900791941_change_7661],
      }
    );
    const act_1984986731969919_emit_7666 = new actions.EmitAction(
      {
        actionArgs: this.act_1984986731969919_emit_7666_getActionArgs,
        events: [],
      }
    );
    const evh_1984986731969919_close_7665 = new actions.EventHandlerImpl(
      {
        action: act_1984986731969919_emit_7666,
        event: "close",
        when: this.evh_1984986731969919_close_7665_getWhen,
        displayName: "emit",
      }
    );
    const act_1984986731969919_showModal_7664 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1984986731969919_showModal_7664_getActionArgs,
        displayName: "createCashPayment",
        events: [evh_1984986731969919_close_7665],
      }
    );
    const evh_1984986731969919_clickPrevent_7663 = new actions.EventHandlerImpl(
      {
        action: act_1984986731969919_showModal_7664,
        event: "click.prevent",
        displayName: "createCashPayment",
      }
    );
    const evh_1984986731969919_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1984986731969919_clickPrevent_7663],
      }
    );
    const act_298505142589676_emit_7670 = new actions.EmitAction(
      {
        actionArgs: this.act_298505142589676_emit_7670_getActionArgs,
        events: [],
      }
    );
    const evh_298505142589676_close_7669 = new actions.EventHandlerImpl(
      {
        action: act_298505142589676_emit_7670,
        event: "close",
        when: this.evh_298505142589676_close_7669_getWhen,
        displayName: "emit",
      }
    );
    const act_298505142589676_showModal_7668 = new actions.ShowModalAction(
      {
        actionArgs: this.act_298505142589676_showModal_7668_getActionArgs,
        displayName: "createBankingPayment",
        events: [evh_298505142589676_close_7669],
      }
    );
    const evh_298505142589676_clickPrevent_7667 = new actions.EventHandlerImpl(
      {
        action: act_298505142589676_showModal_7668,
        event: "click.prevent",
        displayName: "createBankingPayment",
      }
    );
    const evh_298505142589676_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_298505142589676_clickPrevent_7667],
      }
    );
    const act_5738488038990219_emit_7674 = new actions.EmitAction(
      {
        actionArgs: this.act_5738488038990219_emit_7674_getActionArgs,
        events: [],
      }
    );
    const evh_5738488038990219_close_7673 = new actions.EventHandlerImpl(
      {
        action: act_5738488038990219_emit_7674,
        event: "close",
        when: this.evh_5738488038990219_close_7673_getWhen,
        displayName: "emit",
      }
    );
    const act_5738488038990219_showModal_7672 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5738488038990219_showModal_7672_getActionArgs,
        displayName: "createReconciliation",
        events: [evh_5738488038990219_close_7673],
      }
    );
    const evh_5738488038990219_clickPrevent_7671 = new actions.EventHandlerImpl(
      {
        action: act_5738488038990219_showModal_7672,
        event: "click.prevent",
        displayName: "createReconciliation",
      }
    );
    const evh_5738488038990219_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5738488038990219_clickPrevent_7671],
      }
    );
    const act_7481595298497917_emit_7678 = new actions.EmitAction(
      {
        actionArgs: this.act_7481595298497917_emit_7678_getActionArgs,
        events: [],
      }
    );
    const evh_7481595298497917_close_7677 = new actions.EventHandlerImpl(
      {
        action: act_7481595298497917_emit_7678,
        event: "close",
        when: this.evh_7481595298497917_close_7677_getWhen,
        displayName: "emit",
      }
    );
    const act_7481595298497917_showModal_7676 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7481595298497917_showModal_7676_getActionArgs,
        displayName: "createBadDebt",
        events: [evh_7481595298497917_close_7677],
      }
    );
    const evh_7481595298497917_clickPrevent_7675 = new actions.EventHandlerImpl(
      {
        action: act_7481595298497917_showModal_7676,
        event: "click.prevent",
        displayName: "createBadDebt",
      }
    );
    const evh_7481595298497917_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_7481595298497917_clickPrevent_7675],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7656,
      evh_7315092382398562_reload_7655,
      evh_7315092382398562_reload,
      act_4592790460410433_showModal_7658,
      evh_4592790460410433_click_7657,
      evh_4592790460410433_click,
      act_322074727583344_resource_7660,
      evh_322074727583344_change_7659,
      evh_322074727583344_change,
      act_5807883900791941_resource_7662,
      evh_5807883900791941_change_7661,
      evh_5807883900791941_change,
      act_1984986731969919_emit_7666,
      evh_1984986731969919_close_7665,
      act_1984986731969919_showModal_7664,
      evh_1984986731969919_clickPrevent_7663,
      evh_1984986731969919_clickPrevent,
      act_298505142589676_emit_7670,
      evh_298505142589676_close_7669,
      act_298505142589676_showModal_7668,
      evh_298505142589676_clickPrevent_7667,
      evh_298505142589676_clickPrevent,
      act_5738488038990219_emit_7674,
      evh_5738488038990219_close_7673,
      act_5738488038990219_showModal_7672,
      evh_5738488038990219_clickPrevent_7671,
      evh_5738488038990219_clickPrevent,
      act_7481595298497917_emit_7678,
      evh_7481595298497917_close_7677,
      act_7481595298497917_showModal_7676,
      evh_7481595298497917_clickPrevent_7675,
      evh_7481595298497917_clickPrevent,
      OpenPayment: act_4592790460410433_showModal_7658,
      createCashPayment: act_1984986731969919_showModal_7664,
      createBankingPayment: act_298505142589676_showModal_7668,
      createReconciliation: act_5738488038990219_showModal_7672,
      createBadDebt: act_7481595298497917_showModal_7676,
    }
  }
}

Vue.component("UcInvoicePayments", UcInvoicePayments);

</script>